import Api from '@/services/api.js';

export default {
  addVehicleProject(details) {
    return Api.post('vehicleProjects/', details);
  },
  getAllVehicleProjects() {
    return Api.get('vehicleProjects/');
  },
  deleteVehicleProject(vehicleProject) {
    return Api.delete(`vehicleProjects/${vehicleProject}`);
  },
  updateVehicleProject(vehicleProject) {
    var vehicleProjectId = vehicleProject.id;
    return Api.put(`vehicleProjects/${vehicleProjectId}`, vehicleProject);
  },
  getVehicleProjectsById(id, type) {
    if (type == 'vehicle') {
      return this.getVehicleProjectsByVehicle(id)
    } else {
      return this.getVehicleProjectsByProject(id)
    }
  },
  getVehicleProjectsByVehicle(id) {
    return Api.get('vehicleProjects/byVehicle/' + id);
  },
  getVehicleProjectsByProject(id) {
    return Api.get('vehicleProjects/byProject/' + id);
  },
}